import { render, staticRenderFns } from "./concept.vue?vue&type=template&id=c6f0f73a"
import script from "./concept.vue?vue&type=script&lang=js"
export * from "./concept.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports